// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1RgH8","clinicsSelect":"TableHeading_clinicsSelect__EDkhz"};